import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cde0436"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header__btns"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon fc-icon-chevron-left" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#chevron-left" })
], -1))
const _hoisted_3 = { class: "custom-button-text" }
const _hoisted_4 = {
  key: 1,
  class: "custom-button custom-button-left"
}
const _hoisted_5 = { class: "custom-button-text" }
const _hoisted_6 = {
  class: "custom-button-text",
  style: {"margin-left":"5px"}
}
const _hoisted_7 = {
  class: "sprite-icon fc-icon-chevron-right",
  style: {"vertical-align":"middle"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#chevron-right" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 3,
  class: "custom-button custom-button-right"
}
const _hoisted_11 = { class: "custom-button-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.isVehicleDetails)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.isFirstVehicleInList())
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "header-carDetail__btn header-carDetail__btn_prev",
              to: { path: _ctx.navPath('previous') }
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.i18n.t("header.prevCar")), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.i18n.t("header.prevCar")), 1)
            ])),
        (!_ctx.isLastVehicleInList())
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              class: "header-carDetail__btn header-carDetail__btn_next",
              to: { path: _ctx.navPath('next') }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.i18n.t("header.nextCar")), 1),
                (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.i18n.t("header.nextCar")), 1)
            ]))
      ]))
    : _createCommentVNode("", true)
}